import React from 'react';
import * as S from './GoSafeImpInfo.styles';


const GoSafeImpInfo = (props) => {
    const { data } = props;
    if (!data) {
        return <></>;
    }

    return (<>
        {data.data && data.data.length ?
            <S.GoSafeImpWrap>
                <S.GoSafeHeader><S.InfoIcon>i</S.InfoIcon>{data.t}</S.GoSafeHeader>
                <ul style={{ listStyle: 'disc', paddingLeft: "20px" }}>
                    {data.data.map((item, index) => { return (<li key={item.i + index}>{item.i}</li>) })}
                </ul>
            </S.GoSafeImpWrap>
            : <></>
        }
    </>);
}

export default GoSafeImpInfo;
